import { originApi } from '@services/apis';
import { OriginEntityInterface } from '../api/interfaces';

export const createNewSectionsAndBlocksByOriginId = async (
  originId: string,
  origin: OriginEntityInterface
): Promise<OriginEntityInterface> => {
  const response = await originApi.put(`/${originId}/sections/blocks`, origin);
  return response.data;
};
